import { render, staticRenderFns } from "./LinkAddress.vue?vue&type=template&id=eda6d25c&scoped=true&"
import script from "./LinkAddress.vue?vue&type=script&lang=js&"
export * from "./LinkAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda6d25c",
  null
  
)

export default component.exports